// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n';
import zhLocale from './assets/languages/zh';
import enLocale from './assets/languages/en';
import jaLocale from './assets/languages/ja';
import viLocale from './assets/languages/vi';
import elementZhLocale from './assets/languages/zh';
import elementEnLocale from './assets/languages/en';
import elementJaLocale from './assets/languages/ja';
import elementViLocale from './assets/languages/vi';
import getLang from './assets/languages/getLang';
import locale from 'element-ui/lib/locale'
import App from './App'
import Vuex from 'vuex'
import store from '@/stores/index'
import mixin from '@/mixins/mixin'
import general_environment from '@/util/general_environment'
// import store from 'store'
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')
import VCharts from 'v-charts'
Vue.use(VCharts)

// m3u8
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-flash'
import 'videojs-contrib-hls.js/src/videojs.hlsjs'
Vue.use(VueVideoPlayer)

//import store from './vuex/store'
Vue.use(Vuex)
Vue.mixin(mixin)
Vue.mixin(general_environment)
locale.i18n((key, value) => i18n.t(key, value))

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getLang,
  messages: {
    zh: {
      ...zhLocale,
      ...elementZhLocale
    },
    en: {
      ...enLocale,
      ...elementEnLocale
    },
    ja: {
      ...jaLocale,
      ...elementJaLocale
    },
    vi: {
      ...viLocale,
      ...elementViLocale
    },
  }
})
export default i18n



import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, { i18n: (key, value) => i18n.vm._t(key, value) });

import router from './router'

import Public from './util/public'

Vue.prototype.Public = Public;
Vue.use(Public)

import Axios from 'axios'
Vue.prototype.$axios = Axios

import api from './util/axios'
Vue.prototype.$api = api

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  // window.scrollTo(0,0);
  document.getElementById('app').scrollTo(0, 0)
});

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  i18n,
  router,
  store: store,
  components: {
    App
  },
  template: '<App/>',
  render: h => h(App)
})

import swal from './util/vue-sweetalert2'
Vue.prototype.swal = swal;
Vue.use(swal)

import global_ from './components/common/global'
Vue.prototype.global_ = global_;

import ConstPlugin from './plugins/const_plugin'




// WEBPACK FOOTER //
// ./src/main.js